import { FETCH_THERAPY_EVENTS } from '../actions/types';
import { normalize } from './index';

const initialState = {
    all: {}
};

export default function(state = initialState, action) {
    switch(action.type) {
        case `${FETCH_THERAPY_EVENTS}_FULFILLED`:
            return {
                ...state,
                all: {
                    ...state.all,
                    ...normalize(action.payload.data)
                }
            };
        default:
            return state;
    }
}
